import { Form as BootstrapForm } from "react-bootstrap";
import { useEffect, useState } from "react";
import "./FormRadio.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

export type radioDataType = {
  radioLabel: string;
  radioId: string;
  radioName: string;
};
export type formRadioType = {
  radioData: radioDataType[];
  labelText: string;
  defaultValue: string;
  setInfo: React.Dispatch<React.SetStateAction<string>>;
  disabled?: boolean;
};

export const FormRadio = ({
  radioData,
  labelText,
  defaultValue,
  setInfo,
  disabled = false,
}: formRadioType) => {
  const handleSetDefault = (data: radioDataType) => {
    if (data.radioId === defaultValue) {
      return true;
    } else return false;
  };

  useEffect(() => {
    for (let i = 0; i < radioData.length; i++) {
      if (radioData[i].radioId === defaultValue) {
        setInfo(defaultValue);
      }
    }
  }, [defaultValue]);

  return (
    <BootstrapForm.Group as={Row}>
      <BootstrapForm.Label as={"div"} column sm={3} style={{ margin: "auto" }}>
        {labelText}
      </BootstrapForm.Label>
      <Col as={"div"} sm={9}>
        {radioData.map((radio, i) => (
          <BootstrapForm.Check
            key={i}
            inline
            label={radio.radioLabel}
            name={radio.radioName}
            id={radio.radioId}
            defaultChecked={handleSetDefault(radio)}
            type="radio"
            onChange={() => {
              setInfo(radio.radioId);
            }}
            disabled={disabled}
          />
        ))}
      </Col>
    </BootstrapForm.Group>
  );
};
